import React, { FC } from 'react'
import Link from 'next/link'
import theme from 'src/theme/theme'
import {useTranslation} from "react-i18next";
import { LinkWrapper, StripeProps, StripeWrapper } from './styles'

export type PresetStripe = keyof typeof presets

interface Props {
  id?: string
  title: string
  hasIcon: boolean
  hasButton?: boolean
  hasLink?: boolean
  preset?: PresetStripe
  Icon?: React.ElementType
  imageUrl?: string
  onClick?: () => void
  href?: string
}

const StripeComponent: FC<Props> = props => {
  const { t } = useTranslation()
  const { id, title, hasLink = false, Icon, imageUrl, onClick } = props
  const presetStyles = presets[props?.preset || 'primary']
  const icon = Icon ? <Icon className="icon" /> : <img src={imageUrl} alt="Ícone do curso" />
  const anchor = hasLink ? <span className="anchor-text">{t('classes.accessForum')}</span> : null

  const RenderComponent = ({ children }) => {
    if (hasLink) {
      return (
        <LinkWrapper>
          <Link legacyBehavior href={props.href ?? ''} passHref>
            <a>{children}</a>
          </Link>
        </LinkWrapper>
      )
    }

    return children
  }

  return (
    <RenderComponent>
      <StripeWrapper id={id} {...presetStyles} onClick={onClick}>
        <div className="content">
          {icon}
          <div className="wrapper">
            <strong>{title}</strong>
            {anchor}
          </div>
        </div>
      </StripeWrapper>
    </RenderComponent>
  )
}

interface Presets {
  [key: string]: StripeProps
}

const presets: Presets = {
  primary: {
    backgroundColor: theme.colors.primaryBackgroundColor,
  },
  secondary: {
    overflowX: 'hidden',
    backgroundColor: theme.colors.secondaryBackgroundColor,
  },
}

export const Stripe = React.memo(StripeComponent)
